import { styled } from "@mui/material/styles";
import { Box, Fade, IconButton } from "@mui/material";

export const AnimatedContainer = styled(Fade)(({ theme }) => ({
  backgroundColor: "rgba(0, 0, 0, 0.92)",
  borderRadius: "10px",
  position: "absolute",
  top: 0,
  left: 0,
  bottom: 0,
  right: 0,
  zIndex: 20,
}));

export const RootContainer = styled(Box)(({ theme }) => ({
  width: "100%",
  height: "100%",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  paddingLeft: "50px",
  paddingRight: "50px",
}));

export const CloseButton = styled(IconButton)(({ theme }) => ({
  position: "absolute",
  top: 8,
  right: 8,
  color: theme.palette.common.white,
  "&:hover": {
    backgroundColor: "rgba(255, 255, 255, 0.08)",
  },
}));
